import {
    FETCH_BOOKING_STATS,
    FETCH_BOOKING_STATS_FAILURE,
    FETCH_BOOKING_STATS_SUCCESS,
} from 'store/actions/types';
import {
    ORDER_BY_DAY,
} from 'store/reducers/bookingStatsReducer';
import utils from 'helpers/utils';

export const fetchBookingStats = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        base: payload.field ? payload.field : 'created_at',
        interval: ORDER_BY_DAY,
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    // We do not want the interval in the filter list.
    if (payload.filter.hasOwnProperty('interval')) {
        params.interval = payload.filter.interval.value;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, {
            filters: filters,
        });
    }

    return {
        type: FETCH_BOOKING_STATS,
        payload: params,
    };
};

export const fetchBookingStatsFailure = (error) => {
    return {
        type: FETCH_BOOKING_STATS_FAILURE,
        error: error,
    };
};

export const fetchBookingStatsSuccess = (response, payload) => {
    return {
        type: FETCH_BOOKING_STATS_SUCCESS,
        response: response,
        payload: payload,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookingStats/fetchBookingStats.js